// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collision-tab-container {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.collision-rooms {
  width: 240px;
  border-right: 1px solid #333;
  overflow: auto;
}

.collision-room-row {
  padding: 4px 6px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.collision-room-row:hover {
  background-color: rgba(5, 50, 110, 0.5);
}

.collision-room-row.selected {
  color: orange;
}

.collision-room-name.active {
  font-weight: bold;
}

.collision-room-count {
  color: #9aa4b0;
}

.collision-models {
  flex: 1;
  overflow: auto;
  padding-left: 8px;
}

.collision-empty {
  padding: 8px;
  opacity: 0.7;
  font-style: italic;
}

.collision-model-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 90px 110px 110px;
  gap: 8px;
  padding: 4px 6px;
  border-bottom: 1px solid #333;
  cursor: pointer;
}

.collision-model-row:hover {
  background-color: rgba(5, 50, 110, 0.5);
}

.collision-model-row.expanded {
  background-color: rgba(5, 50, 110, 0.7);
}

.collision-collider-detail {
  display: flex;
  height: 220px;
  border-bottom: 1px solid #333;
  background-color: rgba(0, 0, 0, 0.2);
}

.collision-collider-stats {
  width: 220px;
  flex-shrink: 0;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: auto;
  border-right: 1px solid #333;
  background-color: #ffffff;
  color: #1a1a1a;
}

.collision-stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.collision-stat-label {
  color: #6b7280;
  font-size: 11px;
  text-transform: uppercase;
}

.collision-collider-stats .collision-flag.true {
  color: #0a63c9;
}

.collision-collider-stats .collision-flag.false {
  color: #b8391a;
  font-weight: bold;
}

.collision-collider-preview {
  flex: 1;
  min-width: 0;
}

.collision-model-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.collision-shape-type {
  color: #d3b26b;
  white-space: nowrap;
}

.collision-flag.true {
  color: #4da6ff;
}

.collision-flag.false {
  color: #aaaaaa;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/debug-overlay/collision-tab/CollisionTab.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".collision-tab-container {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.collision-rooms {\n  width: 240px;\n  border-right: 1px solid #333;\n  overflow: auto;\n}\n\n.collision-room-row {\n  padding: 4px 6px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.collision-room-row:hover {\n  background-color: rgba(5, 50, 110, 0.5);\n}\n\n.collision-room-row.selected {\n  color: orange;\n}\n\n.collision-room-name.active {\n  font-weight: bold;\n}\n\n.collision-room-count {\n  color: #9aa4b0;\n}\n\n.collision-models {\n  flex: 1;\n  overflow: auto;\n  padding-left: 8px;\n}\n\n.collision-empty {\n  padding: 8px;\n  opacity: 0.7;\n  font-style: italic;\n}\n\n.collision-model-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 90px 110px 110px;\n  gap: 8px;\n  padding: 4px 6px;\n  border-bottom: 1px solid #333;\n  cursor: pointer;\n}\n\n.collision-model-row:hover {\n  background-color: rgba(5, 50, 110, 0.5);\n}\n\n.collision-model-row.expanded {\n  background-color: rgba(5, 50, 110, 0.7);\n}\n\n.collision-collider-detail {\n  display: flex;\n  height: 220px;\n  border-bottom: 1px solid #333;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.collision-collider-stats {\n  width: 220px;\n  flex-shrink: 0;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  overflow: auto;\n  border-right: 1px solid #333;\n  background-color: #ffffff;\n  color: #1a1a1a;\n}\n\n.collision-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.collision-stat-label {\n  color: #6b7280;\n  font-size: 11px;\n  text-transform: uppercase;\n}\n\n.collision-collider-stats .collision-flag.true {\n  color: #0a63c9;\n}\n\n.collision-collider-stats .collision-flag.false {\n  color: #b8391a;\n  font-weight: bold;\n}\n\n.collision-collider-preview {\n  flex: 1;\n  min-width: 0;\n}\n\n.collision-model-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.collision-shape-type {\n  color: #d3b26b;\n  white-space: nowrap;\n}\n\n.collision-flag.true {\n  color: #4da6ff;\n}\n\n.collision-flag.false {\n  color: #aaaaaa;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
